"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Password = void 0;
var _Check = _interopRequireDefault(require("@tvg/fuse-icons/lib/Check"));
var _ChevronRight = _interopRequireDefault(require("@tvg/fuse-icons/lib/ChevronRight"));
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _colours = require("../../fuse-colours/src/colours");
var _config = _interopRequireDefault(require("./config"));
var _passwordModal = _interopRequireDefault(require("./password-modal"));
var _styledPassword = require("./styled-password");
var _utils = require("./utils");
var _excluded = ["className", "dataTestId", "helperText", "state", "formValidationCallback", "showCriteria", "title", "titleTag", "componentId"];
/* eslint-disable react/jsx-indent-props */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-indent */
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef,
  useState = _react["default"].useState;
var passwordRequirementsListConfig = _config["default"].passwordRequirementsListConfig;
var displayName = 'Password';
var propTypes = {
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  helperText: _propTypes["default"].string,
  state: _propTypes["default"].string,
  formValidationCallback: _propTypes["default"].func,
  showCriteria: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  titleTag: _propTypes["default"].string,
  componentId: _propTypes["default"].string
};
var defaultProps = {
  className: 'fuse-password',
  dataTestId: 'fuse-password-data-test-id',
  helperText: '',
  state: 'default',
  formValidationCallback: function formValidationCallback() {},
  showCriteria: true,
  title: 'Create account password',
  titleTag: 'h2',
  componentId: (0, _fuseUtils.uuid)()
};

// eslint-disable-next-line react/prop-types
function RequirementItem(_ref) {
  var requirement = _ref.requirement,
    label = _ref.label,
    isValid = _ref.isValid;
  return /*#__PURE__*/_react["default"].createElement(_styledPassword.StyledListItem, null, /*#__PURE__*/_react["default"].createElement(_styledPassword.StyledListItemIcon, {
    className: "requirementsListIcon",
    dataTestId: "listIcon__".concat(requirement),
    color: isValid ? _colours.Colours.functional.successMid : _colours.Colours.global.grey500,
    icon: /*#__PURE__*/_react["default"].createElement(_Check["default"], null),
    responsiveSize: "small",
    srLabel: "Check Icon"
  }), /*#__PURE__*/_react["default"].createElement(_styledPassword.StyledListItemText, {
    tag: "p",
    type: "paragraph",
    color: "var(--color-global-black)",
    size: "1"
  }, label), isValid && /*#__PURE__*/_react["default"].createElement(_fuseUtils.StyledScreenReaderSpan, null, label, " is valid"));
}
var Password = exports.Password = forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    dataTestId = _ref2.dataTestId,
    helperText = _ref2.helperText,
    propsState = _ref2.state,
    formValidationCallback = _ref2.formValidationCallback,
    showCriteria = _ref2.showCriteria,
    title = _ref2.title,
    titleTag = _ref2.titleTag,
    componentId = _ref2.componentId,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var _useState = useState({
      password: '',
      passwordStrength: 'default',
      passwordError: '',
      passwordState: propsState,
      requirements: {
        hasEightCharacters: false,
        hasLowercaseLetter: false,
        hasUppercaseLetter: false,
        hasNumber: false
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    localPasswordState = _useState2[0],
    setLocalPasswordState = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isModalOpen = _useState4[0],
    setIsModalOpen = _useState4[1];
  var onChangeCallBack = function onChangeCallBack(_ref3) {
    var currentTarget = _ref3.currentTarget;
    var value = currentTarget.value;
    var passwordStrength = (0, _utils.passwordStrengthCheck)(value);
    var hasEightCharacters = value.length >= 8;
    var hasLowercaseLetter = /[a-z]/.test(value);
    var hasUppercaseLetter = /[A-Z]/.test(value);
    var hasNumber = /\d/.test(value);
    var _validatePassword = (0, _utils.validatePassword)(value),
      passwordError = _validatePassword.passwordError,
      passwordValidated = _validatePassword.passwordValidated;
    var passwordState = passwordError ? 'error' : passwordValidated ? 'success' : 'default';
    formValidationCallback({
      password: value,
      passwordValidated: passwordValidated
    });
    setLocalPasswordState(_objectSpread(_objectSpread({}, localPasswordState), {}, {
      password: value,
      passwordStrength: passwordStrength,
      passwordError: passwordError,
      passwordValidated: passwordValidated,
      passwordState: passwordState,
      requirements: {
        hasEightCharacters: hasEightCharacters,
        hasLowercaseLetter: hasLowercaseLetter,
        hasUppercaseLetter: hasUppercaseLetter,
        hasNumber: hasNumber
      }
    }));
  };
  (0, _react.useEffect)(function () {
    if (propsState) {
      setLocalPasswordState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          passwordState: propsState
        });
      });
    }
  }, [propsState]);
  var password = localPasswordState.password,
    passwordState = localPasswordState.passwordState,
    passwordStrength = localPasswordState.passwordStrength;
  var requirementsList = /*#__PURE__*/_react["default"].createElement(_styledPassword.StyledList, null, passwordRequirementsListConfig.map(function (requirement) {
    var isValid = requirement.validate(password);
    return /*#__PURE__*/_react["default"].createElement(RequirementItem, {
      key: requirement.id,
      requirement: requirement.id,
      label: requirement.label,
      isValid: isValid
    });
  }));
  var passwordHelperText;
  if (passwordState === 'error') {
    passwordHelperText = localPasswordState.passwordError || helperText;
  }
  return /*#__PURE__*/_react["default"].createElement(_styledPassword.StyledPasswordContainer, _extends({
    className: className,
    ref: ref,
    "data-testid": dataTestId
  }, rest), /*#__PURE__*/_react["default"].createElement(_styledPassword.StyledPasswordHeader, {
    tag: titleTag,
    type: "heading",
    size: "2"
  }, title), showCriteria && requirementsList, /*#__PURE__*/_react["default"].createElement(_styledPassword.StyledPasswordInput, {
    label: "Enter a password *",
    type: "password",
    state: passwordState,
    maskButton: true,
    helperText: passwordHelperText,
    onChange: function onChange(e) {
      onChangeCallBack(e);
    },
    componentId: componentId
  }), /*#__PURE__*/_react["default"].createElement(_styledPassword.StyledPasswordIndicator, {
    state: passwordStrength
  }), /*#__PURE__*/_react["default"].createElement(_styledPassword.StyledLink, {
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    iconRight: true,
    underline: true,
    onClick: function onClick() {
      return setIsModalOpen(true);
    },
    isButton: true
  }, "Need help creating a password?"), /*#__PURE__*/_react["default"].createElement(_passwordModal["default"], {
    isOpen: isModalOpen,
    onClose: function onClose() {
      return setIsModalOpen(false);
    }
  }));
});
Password.propTypes = propTypes;
Password.displayName = displayName;
Password.defaultProps = defaultProps;
var _default = exports["default"] = Password;